import React from "react";
// import L from "leaflet";
import PropTypes from "prop-types";

export default function StarsRating(props) {
  const type = props.type;
  return (
    <>
      <fieldset
        onChange={e => {
          props.setScore(e.target.value);
        }}
        className={"rating"}
      >
        <input type="radio" id={"star5_" + type} name={type} value="5" />
        <label
          className="full"
          htmlFor={"star5_" + type}
          title="Eccellente - 5 stelle"
        ></label>
        <input type="radio" id={"star4half_" + type} name={type} value="4.5" />
        <label
          className="half"
          htmlFor={"star4half_" + type}
          title="Ottimo - 4.5 stelle"
        ></label>
        <input type="radio" id={"star4_" + type} name={type} value="4" />
        <label
          className="full"
          htmlFor={"star4_" + type}
          title="Buono - 4 stelle"
        ></label>
        <input type="radio" id={"star3half_" + type} name={type} value="3.5" />
        <label
          className="half"
          htmlFor={"star3half_" + type}
          title="Buono - 3.5 stelle"
        ></label>
        <input type="radio" id={"star3_" + type} name={type} value="3" />
        <label
          className="full"
          htmlFor={"star3_" + type}
          title="Sufficiente - 3 stelle"
        ></label>
        <input type="radio" id={"star2half_" + type} name={type} value="2.5" />
        <label
          className="half"
          htmlFor={"star2half_" + type}
          title="Mediocre - 2.5 stelle"
        ></label>
        <input type="radio" id={"star2_" + type} name={type} value="2" />
        <label
          className="full"
          htmlFor={"star2_" + type}
          title="Mediocre - 2 stelle"
        ></label>
        <input type="radio" id={"star1half_" + type} name={type} value="1.5" />
        <label
          className="half"
          htmlFor={"star1half_" + type}
          title="Mediocre - 1.5 stelle"
        ></label>
        <input type="radio" id={"star1_" + type} name={type} value="1" />
        <label
          className="full"
          htmlFor={"star1_" + type}
          title="Molto scarso - 1 stella"
        ></label>
        <input type="radio" id={"starhalf_" + type} name={type} value="0.5" />
        <label
          className="half"
          htmlFor={"starhalf_" + type}
          title="Molto scarso - 0.5 stelle"
        ></label>
      </fieldset>
    </>
  );
}

StarsRating.propTypes = {
  setScore: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
};
